import { SuperAdminClientsSessionsPage } from "../../operator/console/super-admin-clients-sessions";

export default function ConsoleSuperAdminClientsSessions() {
  return <SuperAdminClientsSessionsPage />;
}
